function formatToPost(
  cameras,
  drawMode,
  configId,
  setPostCameras,
  listCameras
) {
  function formatCoordinates(coordinates, width, height) {
    return coordinates.map((coordinate) => [
      coordinate[0].x / width,
      coordinate[0].y / height,
    ]);
  }

  function formatLineCoordinates(coordinates, width, height) {
    return coordinates.map((coordinate) => [
      coordinate.x / width,
      coordinate.y / height,
    ]);
  }

  const new_cameras = {};
  if (drawMode === "zone") {
    for (const [key, value] of Object.entries(cameras)) {
      const new_zones = value.map((zone) => {
        const cameraId = Number(key);
        const camera = listCameras.find((camera) => camera.id === cameraId);
        const width = camera.width;
        const height = camera.height;
        return {
          id: zone.id,
          coordinates: formatCoordinates(zone.coordinates, width, height),
          description: zone.description,
          color: zone.color,
          configuration: configId,
        };
      });
      new_cameras[key] = new_zones;
    }
  } else if (drawMode === "line") {
    for (const [key, value] of Object.entries(cameras)) {
      const new_lines = value.map((line) => {
        const cameraId = Number(key);
        const camera = listCameras.find((camera) => camera.id === cameraId);
        const width = camera.width;
        const height = camera.height;

        const p1 = line.coordinates[0][0];
        const p2 = line.coordinates[0][1];
        const angle = Math.atan2(p2.y - p1.y, p2.x - p1.x);
        const arrowLength = 36;
        const arrow1 = {
          x: p1.x + p2.x / 2 + Math.cos(angle + Math.PI / 2) * arrowLength,
          y: p1.y + p2.y / 2 + Math.sin(angle + Math.PI / 2) * arrowLength,
        };
        const arrow2 = {
          x: p1.x + p2.x / 2 + Math.cos(angle - Math.PI / 2) * arrowLength,
          y: p1.y + p2.y / 2 + Math.sin(angle - Math.PI / 2) * arrowLength,
        };
        const arrow1Norm = [arrow1.x / width, arrow1.y / height];
        const arrow2Norm = [arrow2.x / width, arrow2.y / height];
        let directionArr;
        if (line.selectedArrow === 1) {
          directionArr = [arrow2Norm, arrow1Norm];
        } else {
          directionArr = [arrow1Norm, arrow2Norm];
        }
        return {
          id: line.id,
          coordinates: formatLineCoordinates(
            line.coordinates[0],
            width,
            height
          ),
          description: line.description,
          color: line.color,
          configuration: configId,
          direction: directionArr,
        };
      });
      new_cameras[key] = new_lines;
    }
  }
  setPostCameras(new_cameras);
}

export { formatToPost };
